import { useContext } from 'react'
import { kDefaultLogoPath } from '@/constants/constants-ui'
import { AuthContext } from '@/context/auth-context'
import { SideNavDashboard, SideNavMatter } from '@/components/side-nav/SideNav'
import { useSideNavConfig } from './hooks/useSideNavConfig'
import SidebarAccountMenu from './SidebarAccountMenu'
import SidebarItemSupport from './SidebarItemSupport'
import SidebarItemAnonSignIn from './SidebarItemAnonSignIn'

type DesktopSidebarProps = {
  hideDesktopSidebars?: boolean
}

/**
 * Desktop Sidebar
 *
 * Desktop version of the main navigation component to display feature navigation items.
 * - Static sidebar rendered on desktop (≥ lg) only
 * - Can be collapsed/expanded via `hideDesktopSidebars` along with the chat list
 */
export default function DesktopSidebar(props: DesktopSidebarProps) {
  const { hideDesktopSidebars } = props
  const authContext = useContext(AuthContext)
  const { logoUrl } = authContext
  const isPaxtonLogo = logoUrl === kDefaultLogoPath

  const config = useSideNavConfig()

  const renderFooter = () => (
    <>
      <SidebarItemSupport />
      <SidebarItemAnonSignIn />
      <SidebarAccountMenu />
    </>
  )

  // Animation wrapper for hide/show sidebar
  return (
    <div className="flex h-full">
      <div className={`inset-y-0 z-50 flex flex-col overflow-hidden transition-all ease-in-out duration-500 ${hideDesktopSidebars ? 'w-0' : 'w-[254px]'}`}>
        {config.variant === 'dashboard' ? (
          <SideNavDashboard
            logoUrl={logoUrl}
            hasFixedLogoHeight={isPaxtonLogo}
            activeItemId={config.activeItemId}
            items={config.items}
            renderFooter={renderFooter}
          />
        ) : (
          <SideNavMatter
            logoUrl={logoUrl}
            hasFixedLogoHeight={isPaxtonLogo}
            activeItemId={config.activeItemId}
            topItems={config.topItems}
            collapsibleGroup={config.collapsibleGroup}
            renderFooter={renderFooter}
          />
        )}
      </div>
    </div>
  )
}
